var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "54px",
    viewBox: "0 0 48 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-550.000000, -105.000000)",
    fill: "#54575A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(550.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.669869,5.85351562 L40.0558952,5.85351562 L40.0558952,4.07109375 C40.0558952,1.82460937 38.2951965,0 36.1257642,0 C33.9563319,0 32.1956332,1.82460937 32.1956332,4.07109375 L32.1956332,5.84296875 L28.1606987,5.84296875 L28.1606987,4.07109375 C28.1606987,1.82460937 26.4,0 24.2305677,0 C22.0611354,0 20.3004367,1.82460937 20.3004367,4.07109375 L20.3004367,5.84296875 L16.2655022,5.84296875 L16.2655022,4.07109375 C16.2655022,1.82460937 14.5048035,0 12.3353712,0 C10.1659389,0 8.40524017,1.82460937 8.40524017,4.07109375 L8.40524017,5.84296875 L6.330131,5.84296875 C2.88209607,5.84296875 0.0733624454,8.66953125 0.0733624454,12.1394531 L0.0733624454,47.6929687 C0.0733624454,51.1628906 2.88209607,53.9894531 6.330131,53.9894531 L41.6593886,53.9894531 C45.1074236,53.9894531 47.9161864,51.1628906 47.9161864,47.6929687 L47.9161864,12.1394531 C47.9266376,8.66953125 45.1179039,5.85351562 41.669869,5.85351562 Z M34.3965066,4.07109375 C34.3965066,3.04804688 35.1720524,2.21484375 36.1152838,2.21484375 C37.0689956,2.21484375 37.8340611,3.04804687 37.8340611,4.07109375 L37.8340611,11.3273438 C37.8340611,12.3503906 37.0585153,13.1835938 36.1152838,13.1835938 C35.1615721,13.1835938 34.3965066,12.3503906 34.3965066,11.3273438 L34.3965066,4.07109375 Z M22.50131,4.07109375 C22.50131,3.04804688 23.2768559,2.21484375 24.2200873,2.21484375 C25.1737991,2.21484375 25.9388646,3.04804687 25.9388646,4.07109375 L25.9388646,11.3273438 C25.9388646,12.3503906 25.1633188,13.1835938 24.2200873,13.1835938 C23.2663755,13.1835938 22.50131,12.3503906 22.50131,11.3273438 L22.50131,4.07109375 L22.50131,4.07109375 Z M10.6061135,4.07109375 C10.6061135,3.04804688 11.3816594,2.21484375 12.3248908,2.21484375 C13.2786026,2.21484375 14.0436681,3.04804687 14.0436681,4.07109375 L14.0436681,11.3273438 C14.0436681,12.3503906 13.2681223,13.1835938 12.3248908,13.1835938 C11.371179,13.1835938 10.6061135,12.3503906 10.6061135,11.3273438 L10.6061135,4.07109375 Z M44.2480349,47.7035156 C44.2480349,49.1378906 43.0951965,50.2980469 41.669869,50.2980469 L6.330131,50.2980469 C4.90480349,50.2980469 3.75196507,49.1378906 3.75196507,47.7035156 L3.75196507,15.1136719 L44.2375546,15.1136719 L44.2375546,47.7035156 L44.2480349,47.7035156 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.07423581,
    y: 21.6738281,
    width: 6.75982533,
    height: 6.05390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.0978166,
    y: 21.6738281,
    width: 6.77030568,
    height: 6.05390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.1318777,
    y: 21.6738281,
    width: 6.75982533,
    height: 6.05390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1659389,
    y: 21.6738281,
    width: 6.77030568,
    height: 6.05390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.07423581,
    y: 29.7527344,
    width: 6.75982533,
    height: 6.05390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.0978166,
    y: 29.7527344,
    width: 6.77030568,
    height: 6.05390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.1318777,
    y: 29.7527344,
    width: 6.75982533,
    height: 6.05390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1659389,
    y: 29.7527344,
    width: 6.77030568,
    height: 6.05390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.07423581,
    y: 37.8421875,
    width: 6.75982533,
    height: 6.05390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.0978166,
    y: 37.8421875,
    width: 6.77030568,
    height: 6.05390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.1318777,
    y: 37.8421875,
    width: 6.75982533,
    height: 6.05390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1659389,
    y: 37.8421875,
    width: 6.77030568,
    height: 6.05390625
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.eb4f617d3b4e228d5100c5b138095a54.svg";
export { ForwardRef as ReactComponent };